export const tsmtWebinar = {
  seo: {
    title: "Bespire webinar for TSMT® therapists · July 20 & 23",
    description:
      "Free 1-hour online webinar for TSMT® therapists. Bespire is a full AI assistant — brand, website, blog/SEO, marketing, email, booking, CRM in one place. We show 3 of these live on the webinar.",
  },
  header: {
    cta: "Register",
  },
  hero: {
    eyebrow: "Bespire × TSMT® · Free webinar",
    title: "Meet Bespire — a live webinar for TSMT® therapists",
    subtitle:
      "Bespire is a full AI assistant for service pros — brand, website, blog/SEO, marketing, email, booking, CRM, team in one place. In 1 hour we show live how it runs the daily work for you.",
    trust: ["Free", "Online, Zoom", "For TSMT® therapists", "Q&A included"],
    dates: [
      { label: "Session 1", date: "Monday, July 20", time: "1:00 – 2:00 PM" },
      { label: "Session 2", date: "Thursday, July 23", time: "10:00 – 11:00 AM" },
    ],
    datesNote: "Pick the one that suits you when you register.",
    cta: "Register for the webinar",
    ctaHint: "Registration takes a few clicks in a Google Form.",
  },
  testimonial: {
    title: "How Bespire helps Gonda Cili",
    subtitle: "Real customer, real experience — see how it changed her day-to-day.",
    videoAriaLabel: "Play the customer interview video",
    playAriaLabel: "Play video",
    quote: "Bespire isn't just a website — it's the key to my freedom as an entrepreneur.",
    customerName: "Gonda Cili",
    customerRole: "Manual therapist",
    customerCity: "Budapest",
    cta: "Register for the webinar",
  },
  audience: {
    eyebrow: "Who it's for",
    title: "If this sounds familiar, the webinar is for you.",
    items: [
      { title: "Scheduling eats your time", description: "Phone, message, calendar — tracked in three places, things still slip." },
      { title: "No clear online presence", description: "You have no site, or one that isn't bookable and doesn't reflect what you actually do." },
      { title: "Little time for marketing", description: "You know you should post and send newsletters — but in practice there's no time." },
    ],
  },
  agenda: {
    eyebrow: "Agenda",
    title: "What we'll cover in 1 hour",
    subtitle: "A short walkthrough of how Bespire supports your daily work.",
    items: [
      { n: "01", title: "What is Bespire and how does it help therapists?", description: "How the system supports presenting your services, gaining clients and running day-to-day." },
      { n: "02", title: "Your own online presence, simply", description: "How to build a professional site, service list and booking page — no technical skills." },
      { n: "03", title: "Appointments, leads and client flows", description: "How the system reduces manual coordination and admin." },
      { n: "04", title: "AI assistant in daily work", description: "How AI helps with writing, communication, marketing and explaining services clearly." },
      { n: "05", title: "Discounted access for TSMT® therapists", description: "The discounted access through the TSMT® partnership and how to join." },
      { n: "06", title: "Q&A", description: "Concrete questions, practical examples and your specific situation." },
    ],
  },
  screenshots: {
    eyebrow: "What you'll see live",
    title: "Not slides — a live AI assistant, real screens.",
    items: [
      { title: "A finished, bookable practice site", description: "Built and edited via AI chat. No code, no template hunting — describe what you want and it's ready in minutes." },
      { title: "A clear booking calendar", description: "Sessions, locations, breaks, recurring slots — one calendar. The AI assistant helps you set it up and update it fast." },
    ],
  },
  benefits: {
    eyebrow: "What we'll show",
    title: "What Bespire replaces day to day",
    teaserLabel: "And much more",
    teaserMore: "…which we'll show you live on the webinar.",
    items: [
      { title: "Booking", description: "Online booking, automatic reminders, cancellation handling." },
      { title: "Presenting services", description: "1:1, group, home-exercise packs — clearly, in one place." },
      { title: "Online presence", description: "Your own practice site, on your own domain if you want, no tech skills." },
      { title: "AI assistant", description: "Copy, posts, newsletters, client comms — in one chat." },
      { title: "Admin", description: "Invoicing, reminders, client lists — inside the AI assistant." },
      { title: "\n", description: "\n" },
    ],
  },
  mockup: {
    eyebrow: "Example",
    title: "Marketing plan, posts and ads — in one chat.",
    subtitle: "Weekly content, Instagram / Facebook / TikTok posts, ads — the AI assistant writes and schedules them.",
    marketingTitle: "Marketing plan",
    marketingGoalLabel: "Goal",
    marketingGoal: "Reach new parents for summer TSMT® sessions",
    marketingChannelsLabel: "Channels",
    channels: ["Instagram", "Facebook", "TikTok"],
    marketingWeeklyLabel: "Weekly plan",
    weeklyPlan: [
      { day: "Monday", content: "Intro post: who TSMT® helps" },
      { day: "Wednesday", content: "Tip post: 3 games at home" },
      { day: "Friday", content: "Ad: summer session promo" },
    ],
    marketingCta: "Create ad",
    chat: {
      title: "AI assistant",
      user: "Write a Facebook ad for the new summer TSMT® sessions.",
      ai: "Done — 3 versions: an emotional one for parents, a professional one mentioning outcomes, and a short video caption. Shall we target 25 km around the city?",
    },
  },
  why: {
    eyebrow: "Why join",
    title: "One hour — clearer operations after.",
    items: [
      "You see real, working screens — not just slides.",
      "You can ask questions — there's a Q&A block at the end.",
      "Registrants get the recording afterwards.",
      "Discounted access for TSMT® therapists.",
    ],
  },
  faq: {
    eyebrow: "FAQ",
    title: "Good to know",
    items: [
      { q: "How much does the webinar cost?", a: "Free, for TSMT® therapists." },
      { q: "Do I need prior knowledge?", a: "No. The webinar is built so beginners can follow." },
      { q: "Will there be a recording?", a: "Yes. Registrants get the recording by email." },
      { q: "Do I have to pay or subscribe afterwards?", a: "No. You decide after the webinar. TSMT® discount details are shared on the webinar." },
      { q: "Which platform is it on?", a: "Zoom. The meeting link is emailed after registration." },
      { q: "How do I register?", a: "Click Register and fill in a short Google Form, then pick your slot." },
    ],
  },
  closing: {
    title: "Book your spot on the webinar.",
    subtitle: "Two sessions to choose from. Free, for TSMT® therapists.",
    cta: "Register for the webinar",
    ctaHint: "Google Form, about 30 seconds.",
  },
  footer: {
    tagline: "Bespire × TSMT® — webinar for therapists",
    contact: "Questions? zoltan@bespire.io",
  },
};
